import ROUTES from "../../../../configs/routesConfig";
import { Row, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { useCallback, useState, MouseEvent } from "react";
import { HelpModal } from "../../../HelpModal";
import { useAppDispatch } from "../../../../store";
import { useNavigate, NavigateFunction, Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { useLocation, Location } from "react-router-dom";
import { useLogoRedirectPath } from "../../../../lib/hooks/useLogoRedirectPath";
import { NavItems } from "./NavItems";
import { setLocation } from "../../../../acions/actionsCreators/nextLocation";
import { useHasAdministrationAccess } from "../../../../lib/PermissionContainer/hooks/useHasAdministrationAccess";
import { useLogout } from "../../hooks/useLogout";
import Logo from "../Logo";
import ProfileLink from "../ProfileLink";
import { ScopeSpecificLink } from "../ScopeSpecificLink";
import { useSelector } from "react-redux";
import { CarryOutOutlined } from "@ant-design/icons";
import "../../styles.scss";
import { useGetRole } from "../../../../lib/hooks/getRole";
import USER_ROLES from "../../../../types/UserRoles";

export const AdminHeader = () => {
  const dispatch = useAppDispatch();
  const navigate: NavigateFunction = useNavigate();
  const location: Location = useLocation();

  const [role] = useGetRole();

  const { canViewAdministration } = useHasAdministrationAccess();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { logoRedirectPath } = useLogoRedirectPath();

  const setNextLocation = useCallback(
    (e: MouseEvent<HTMLAnchorElement>): void => {
      const path = e.currentTarget.id;

      dispatch(setLocation(path));
    },
    [dispatch]
  );

  const { onLogout } = useLogout();

  const openModal = useCallback(() => setIsModalOpen(true), []);

  const unprocessedWorkTasksCount = useSelector((state: any) => state.systemState.unprocessedWorkTasksCount);

  return (
    <>
      <Row className="justify-space-between logged-header__container">
        <Row>
          <Link className="py-5 mr-8" to={logoRedirectPath} id={logoRedirectPath} onClick={setNextLocation}>
            <Logo />
          </Link>
          {role !== USER_ROLES.INTEGRATION_RECEPTIONIST && (
            <NavItems location={location} navigate={navigate} setNextLocation={setNextLocation} />
          )}
        </Row>
        <Row>
          {role !== USER_ROLES.INTEGRATION_RECEPTIONIST && (
            <ScopeSpecificLink
              hasNotification={!!unprocessedWorkTasksCount}
              icon={<CarryOutOutlined />}
              route={ROUTES.TASKS}
            />
          )}
          <ProfileLink />
          {canViewAdministration && (
            <Link
              className={`d-flex align-center header-button py-0 px-4 ${
                location.pathname === ROUTES.ADMINISTRATION ? "active" : ""
              }`}
              to={ROUTES.ADMINISTRATION}
              id={ROUTES.ADMINISTRATION}
              onClick={setNextLocation}
            >
              <SettingOutlined />
            </Link>
          )}
          <Button type="text" className="header-button" onClick={openModal}>
            Help
          </Button>
          <Button type="text" className="header-button desktop-btn" onClick={onLogout}>
            Log out
          </Button>
        </Row>

        <HelpModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      </Row>

      <Outlet />
    </>
  );
};
